// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Modules
import { Header } from '@/modules/Layout';
import { selectChannelId } from '@/modules/Channels';

// Store
import { useAppState } from '@/store';

// Components
// import { Button } from '@/ui';
// import { PlusIcon } from '@/icons';
import { CouponsTable } from '../../components';
import { StyledContainer } from './CouponsContainerStyles';

// Helpers
// import { useBoolean } from '@/hooks';
import { useGetCoupons } from '../../hooks';

const CouponsContainer: FC = () => {
  const { t } = useTranslation();
  const channelId = useAppState(selectChannelId);
  const { coupons, isLoading } = useGetCoupons(channelId);
  // const { value: isCreateModalOpen, toggle: handleToggleCreateModal } = useBoolean();

  return (
    <>
      <Header title={t('menu_coupons')}>
        {/* <Button icon={<PlusIcon />} type="primary" onClick={handleToggleCreateModal}>
          {t('create_coupon')}
        </Button> */}
      </Header>
      <StyledContainer>
        <CouponsTable coupons={coupons} isLoading={isLoading} />
      </StyledContainer>
      {/* <CreateCouponModal isOpen={isCreateModalOpen} onClose={handleToggleCreateModal} /> */}
    </>
  );
};

export default CouponsContainer;
